<template>
    <v-form ref="selectTypePasswordDelivery" v-model="valid" lazy-validation>
        <div class="password-recovery">
            <div class="password-recovery__title" v-if="!confirmedApiResponse && recoveryData.recoveryPhoneNumber">
                {{loginConstants.PASSWORD_RECEIVING_TYPE}}
            </div>
        </div>
        <v-layout justify-space-between row v-if="!confirmedApiResponse && recoveryData.email && recoveryData.recoveryPhoneNumber">
            <v-flex xs2>
                <v-icon>email</v-icon>
            </v-flex>
            <v-flex xs10>
                <v-checkbox
                        color="ypo_blue"
                        id="email_delivery_type_checkbox"
                        data-qe-id="email_delivery_type_checkbox"
                        :label="recoveryData.email"
                        v-if="recoveryData.email"
                        v-model="emailBoxChecked"
                        @click="boxCheck('email')"
                ></v-checkbox>
            </v-flex>
        </v-layout>
        <v-layout row v-if="!confirmedApiResponse && recoveryData.recoveryPhoneNumber">
            <v-flex xs2>
                <v-icon v-if="recoveryData.recoveryPhoneNumber">phone_iphone</v-icon>
                <span v-if="recoveryData.recoveryPhoneNumber" class="asterik">{{loginConstants.ASTERIK}}</span>
            </v-flex>
            <v-flex xs10>
                <v-checkbox
                        color="ypo_blue"
                        id="text_delivery_type_checkbox"
                        data-qe-id="text_delivery_type_checkbox"
                        :label="recoveryData.recoveryPhoneNumber"
                        v-if="recoveryData.recoveryPhoneNumber"
                        v-model="smsBoxChecked"
                        @click="boxCheck('sms')"
                ></v-checkbox>
            </v-flex>
        </v-layout>
        <v-flex v-if="confirmedApiResponse && !isSubmitting">
            <div class="forgot-password__success">
                <div class="forgot-password__success-message">{{loginConstants.PASSWORD_EMAIL_SUCCESS}}</div>
                <div class="recovery-code__success-media">{{selectedRecoveryType}}</div>
            </div>
            <v-btn
                    id="resend_email_btn"
                    data-qe-id="resend_email_btn"
                    @click="submit"
                    :disabled="isSubmitting"
                    color="ypo_blue"
                    flat
            >
                <v-icon color="ypo_blue_secondary" left>replay</v-icon>
                {{loginConstants.RESEND_EMAIL}}
            </v-btn>
        </v-flex>
        <login-error></login-error>
        <v-card-actions v-if="recoveryData.email && recoveryData.recoveryPhoneNumber">
            <v-layout row wrap pt-4>
                <div v-if="recoveryData.recoveryPhoneNumber" class="standard-billing">
                    {{loginConstants.STANDARD_BILING}}
                </div>
                <v-btn
                        flat
                        large
                        id="return_to_home_btn"
                        data-qe-id="return_to_home_btn"
                        block
                        :class="confirmedApiResponse ? 'white--text' : 'ypo_blue--text'"
                        :color="confirmedApiResponse ? 'ypo_gold' : ''"
                        @click="returnToLogin()"
                        :disabled="isSubmitting"
                        >
                        {{loginConstants.CANCEL}}
                    </v-btn>
               
                   
                    <v-btn  v-if="!confirmedApiResponse"
                        id="submit_password_recovery_btn"
                        data-qe-id="submit_password_recovery_btn"
                        color="ypo_blue"
                        class="white--text"
                        @click="submit"
                        :disabled="disableContinueButton || !valid || isSubmitting"
                        large
                        block
                        >
                        {{loginConstants.SUBMIT}}
                    </v-btn>
               
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";

    export default {
        name: 'SelectTypePasswordDelivery',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            confirmedApiResponse: null,
            emailBoxChecked: false,
            smsBoxChecked: false,
            checkboxValue: '',
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        created() {
            if (this.recoveryData.recoveryPhoneNumber === null) {
                this.toggleProgressIndicator();
                const selectedPasswordDelivery = { recoveryCodeType: 'email', destination: this.recoveryData.email };
                this.submitSelectTypePasswordDelivery(selectedPasswordDelivery)
                    .then((resp) => {
                        this.toggleProgressIndicator();
                        this.confirmedApiResponse = resp.data;
                        this.changeCardState(this.componentNames.passwordCodeSent.component);
                    })
                    .catch(() => {
                    //TODO: handle error
                    this.toggleProgressIndicator();
                    });
             }
        },
        methods: {
            ...mapActions({
                submitSelectTypePasswordDelivery: `auth/${storeAction.submitSelectTypePasswordDelivery}`,
            }),
            submit() {
                this.toggleProgressIndicator();

                if (this.$refs.selectTypePasswordDelivery.validate()) {
                    const selectedPasswordDelivery = { recoveryCodeType: this.checkboxValue };
                    if (selectedPasswordDelivery.recoveryCodeType === "sms") {
                        selectedPasswordDelivery.destination = this.recoveryData.recoveryPhoneNumber;
                    } else {
                        selectedPasswordDelivery.destination = this.recoveryData.email;
                    }

                    this.submitSelectTypePasswordDelivery(selectedPasswordDelivery)
                        .then((resp) => {
                            this.toggleProgressIndicator();
                            this.confirmedApiResponse = resp.data;
                            this.changeCardState(this.componentNames.passwordCodeSent.component);
                        })
                        .catch(() => {
                            //TODO: handle error
                            this.toggleProgressIndicator();
                        });
                }
            },
            boxCheck(value) {
                if (value === 'email') {
                    this.smsBoxChecked = false;
                    this.emailBoxChecked = true;
                    this.checkboxValue = 'email';
                } else {
                    this.emailBoxChecked = false;
                    this.smsBoxChecked = true;
                    this.checkboxValue = 'sms';
                }
            },

        },
        computed: {
            ...mapGetters({
                recoveryData: `auth/${storeGetters.passwordFurtherAssistance}`,
            }),
            selectedRecoveryType() {
                if (this.radioValue) {
                    return this.radioValue === this.loginConstants.recoveryValues.email
                        ? this.recoveryData.Email
                        : this.recoveryData.RecoveryPhoneNumber;
                }
            },
            disableContinueButton() {
                if (this.emailBoxChecked || this.smsBoxChecked) return false;
                return true;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .password-recovery {
        display: flex;
        flex-direction: column;

        &__title {
            padding: 5px 10px 30px 5px;
            font-size: 16px;
            color: $black;
            opacity: 0.9;
        }

        &__subTitle {
            padding: 5px 10px 20px;
            text-align: center;
            font-size: 16px;
            color: $ypo-blue;
        }

        &__success {
            padding: 10px 5px;
            border-top: 1px solid $ypo-gray;
            display: flex;
            flex-wrap: wrap;

            &-message {
                color: $ypo-blue;
            }

            &-email {
                color: $ypo-gold;
                padding-left: 5px;
            }

            &-media {
                color: $ypo-gold;
                padding-left: 5px;
            }
        }

        &__resend {
            color: $ypo-blue-secondary;
        }
    }

    .standard-billing {
        font-size: 10px;
        letter-spacing: 0.09px;
        position: absolute;
        right: 0;
        top: 10px;
    }

    .v-btn__content {
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;
        padding-left: 0 !important;
        position: relative;
        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

    .date-of-birth, .month-of-birth {
        padding-right: 10px;
    }

    .padding {
        padding-top: 35px;
    }

    .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
    }

    .v-input--selection-controls .v-input__slot {
        margin-bottom: 0;
    }

    .asterik {
        vertical-align: top;
        color: $ypo-blue;
        font-size: 15px;
    }


</style>
